// Extended collection of Ghanaian folktales and myths (summaries are original)
export const AFIA_FOLKTALES_EXTRA = [
  {
    id: 'anansi-skystories',
    title: "How the Sky-God's Stories Came to Be Anansi's Stories",
    keywords: ['anansi', 'sky god', 'nyame', 'stories came to be'],
    intro: 'A classic account of how Kwaku Anansi won the stories from the sky-god Nyame.',
    parts: [
      'Anansi accepts impossible tasks from Nyame and captures dangerous beings—python, hornets, leopard, and the little dwarf—by trick and courage.',
      'At the end he is rewarded with the sky-god’s store of stories, and the world gains the many tales that teach, warn, and make children laugh.'
    ],
    qa: { default: 'The tale explains why humans have stories and why Anansi is a keeper of tales.' },
  },
  {
    id: 'anansi-pot-wisdom',
    title: 'Anansi and the Pot of Wisdom',
    keywords: ['anansi', 'pot of wisdom', 'wisdom', 'calabash'],
    intro: 'Anansi tries to hoard all the world’s wisdom in a pot but learns a lesson about sharing.',
    parts: [
      'Believing he can keep wisdom for himself, Anansi hides a pot in a tree, but struggles to climb with it.',
      'When his son offers a simple solution, Anansi’s pride breaks the pot and wisdom scatters so that all people may carry a piece of it.'
    ],
    qa: { default: 'The story teaches that wisdom belongs to the people and cannot be safely held by one greedy heart.' },
  },
  {
    id: 'anansi-bald-head',
    title: 'How Anansi Got a Bald Head',
    keywords: ['anansi', 'bald head', 'wife', 'funeral'],
    intro: 'A comic tale explaining why Anansi is sometimes mocked and how his vanity brought embarrassment.',
    parts: ['Anansi lies and brags to win praise, and through a string of foolish acts at a funeral he loses his hair and pride.'],
    qa: { default: 'It warns against pride and the trouble of making up stories to impress others.' },
  },
  {
    id: 'anansi-tied-tiger',
    title: 'How Anansi Tied Tiger',
    keywords: ['anansi', 'tiger', 'tie tiger', 'trickster'],
    intro: 'Anansi uses cunning, a basket, and a trick to outwit a much stronger rival.',
    parts: ['The Spider fools Tiger with boasts and a clever trap that leaves Tiger humbled—showing wit can beat size.'],
    qa: { default: 'The tale praises cleverness but also reveals its limits when used without care.' },
  },
  {
    id: 'anansi-became-spider',
    title: 'Why Anansi Became a Spider',
    keywords: ['anansi', 'spider', 'become spider', 'origin tale'],
    intro: 'An origin story that ties Anansi’s shape to a moral twist of fate and the world’s ordering.',
    parts: ['Through trickery, bargains with spirits, or a transformed punishment in different tellings, Anansi ends as the spider figure known across Akan and diaspora stories.'],
    qa: { default: 'Different versions explain the change, but all highlight the trickster’s close link with craft and story.' },
  },
  {
    id: 'anansi-webs-flies',
    title: "Why Anansi's Webs Trap Flies",
    keywords: ['anansi', 'webs', 'flies', 'why webs trap flies'],
    intro: 'A small episode that explains one of Anansi’s everyday tricks and its comic payoff.',
    parts: ['Anansi weaves an especially clever web to catch gossiping flies; their chatter becomes his meal and a lesson to talk less.'],
    qa: { default: 'It is a playful reminder about the cost of careless speech.' },
  },
  {
    id: 'tortoise-cracked-shell',
    title: "Why Tortoise's Shell Is Cracked",
    keywords: ['tortoise', 'cracked shell', 'birds', 'trick'],
    intro: 'A popular West African tale in which Tortoise’s greed causes his fall and the shell’s fracture.',
    parts: ['Tortoise borrows feathers to join the birds and trick them but is betrayed; his shell is later cracked when the birds remove his trick, leaving the mark we see today.'],
    qa: { default: 'The story warns against deceit and the long memory of those you harm.' },
  },
  {
    id: 'pineapple-child',
    title: 'The Pineapple Child',
    keywords: ['pineapple child', 'peggy appiah', 'pineapple', 'child'],
    intro: 'A sweet tale from Ashanti collections about a child born from a fruit, teaching care and wonder.',
    parts: ['When a child appears where a pineapple once grew, the family learns compassion, community care, and the unexpected sources of blessing.'],
    qa: { default: 'It celebrates kinship and the small miracles that enter ordinary households.' },
  },
  {
    id: 'anansewa-marriage',
    title: 'Anansewa (The Marriage of Anansewa)',
    keywords: ['anansewa', 'marriage', 'play', 'anansi'],
    intro: 'A humorous play and extended tale about Anansi’s family life and marriage arrangements.',
    parts: ['The story explores pride, negotiation, and the comic costs of Anansi’s schemes when he seeks a grand match for his daughter.'],
    qa: { default: 'Often staged as a play, it uses folk motifs to examine social expectations and status.' },
  },
  {
    id: 'golden-stool-myth',
    title: 'The Golden Stool and the Spirit of the Ashanti',
    keywords: ['golden stool', 'ashanti', 'stool', 'okomfo anokye'],
    intro: 'A foundational symbol-story of the Asante people: the Golden Stool is said to hold the soul of the nation.',
    parts: ['Called down by Okomfo Anokye, the stool links living kings, ancestors, and future generations; attempts to seize it fueled the famous resistance against British demands.'],
    qa: { default: 'The stool explains sacred kingship and why certain objects are treated as living in Akan political life.' },
  },
  {
    id: 'why-men-evil-night',
    title: 'Why Men Commit Evil at Night',
    keywords: ['why men commit evil at night', 'anansi', 'nyame', 'moon'],
    intro: 'A mythic tale connecting Anansi’s schemes with the ordering of day and night.',
    parts: ['Through Anansi’s involvement with the sons of Nyame, certain behaviors are placed into the rhythms of night and day, offering an imaginative reason for human patterns.'],
    qa: { default: 'It is an etiological tale explaining the structure of time and social order.' },
  },
  {
    id: 'how-diseases-brought',
    title: 'How Diseases were Brought to the Tribe',
    keywords: ['disease', 'anansi', 'origins of disease'],
    intro: 'A cautionary tale where Anansi’s meddling explains why illness enters the village.',
    parts: ['By trick or neglect, Anansi releases an unwanted thing into the world and the community must learn rites of purification and care.'],
    qa: { default: 'The tale teaches hygiene, community response, and the moral cost of shortcuts.' },
  },
  {
    id: 'why-anansi-runs-on-water',
    title: 'Why Anansi Runs When He Is on the Surface of Water',
    keywords: ['anansi', 'water', 'run', 'why runs'],
    intro: 'A short comic origin explaining one of Anansi’s odd habits as a result of trickery gone wrong.',
    parts: ['Anansi’s attempt to take a shortcut across water leads to an awkward escape that becomes a tale told to children about quick thinking and humility.'],
    qa: { default: 'It highlights that quick escapes leave lasting marks on behavior.' },
  },
  {
    id: 'anansi-and-gods',
    title: 'How Anansi Tricked Two Gods',
    keywords: ['anansi', 'gods', 'tricked gods', 'cunning'],
    intro: 'Anansi once tricked divine messengers and even lesser gods, revealing a trickster who can cross mortal and sacred realms.',
    parts: ['Using disguise and lies, Anansi provokes laughter and anger in equal measure, showing how human cunning can test the limits of divine patience.'],
    qa: { default: 'The tale questions the boundary between human cleverness and cosmic order.' },
  },
  {
    id: 'anansi-family-episodes',
    title: 'Anansi Family Episodes',
    keywords: ['anansi', 'family', 'aso', 'ntikuma', 'tikelenkelen'],
    intro: 'A set of short episodes about Anansi’s household—his wives, sons, and domestic follies.',
    parts: ['Stories show Aso’s patience, Ntikuma’s bluntness, and how family life humbles a trickster who often learns from his children.'],
    qa: { default: 'They teach domestic virtues and the importance of listening to kin.' },
  },
  {
    id: 'tale-of-the-leopard',
    title: 'How the Leopard Lost His Pride',
    keywords: ['leopard', 'stripes', 'spots', 'etiology'],
    intro: 'An etiological tale connecting dance, trickery, and the patterning of animals.',
    parts: ['Through competitions and Anansi’s meddling, animal forms are shaped and social roles decided.'],
    qa: { default: 'Animal features are read as the results of communal contests and moral consequences.' },
  },
  {
    id: 'village-iron-man',
    title: 'The Man Who Brought Iron',
    keywords: ['iron', 'smith', 'origin of iron', 'craft'],
    intro: 'A myth about how the knowledge of ironworking came to a community and the responsibilities it carried.',
    parts: ['A traveling smith teaches a village to work iron, changing agriculture, war, and ritual; the tale stresses respect for craft and the obligations of new power.'],
    qa: { default: 'New technologies change social life and require ethical use.' },
  },
  {
    id: 'yam-and-harvest-tale',
    title: 'The Yam That Saved the Village',
    keywords: ['yam', 'harvest', 'homowo', 'famine'],
    intro: 'A story of scarcity and a clever plan that restores plenty at harvest time.',
    parts: ['When famine looms, a bold plan or a generous stranger brings back the harvest and teaches humility to those who hoarded.'],
    qa: { default: 'Communal sharing and ritual thanksgiving are central lessons.' },
  },
  {
    id: 'spirit-wife',
    title: 'The Man Who Married a River Spirit',
    keywords: ['spirit wife', 'river spirit', 'marriage', 'taboo'],
    intro: 'A cautionary romance where a mortal marries a spirit and learns the costs of crossing boundaries.',
    parts: ['Love between a human and an abosom leads to secret rules and tests; breaking them brings loss unless restored by ritual.'],
    qa: { default: 'Respect for sacred boundaries and the power of ritual repair are emphasized.' },
  },
  {
    id: 'hunter-and-forest-giant',
    title: 'The Hunter and the Forest Giant',
    keywords: ['hunter', 'giant', 'forest', 'trial'],
    intro: 'A hero tale where a clever hunter must face a giant and a trial of courage.',
    parts: ['Through wit more than brute force, the hunter completes tasks that restore balance between village and wild places.'],
    qa: { default: 'Courage guided by wisdom keeps community and nature in balance.' },
  },
  {
    id: 'queen-yaa-story',
    title: 'Queen Mother Yaa Asantewaa (legendary deeds)',
    keywords: ['yaa asantewaa', 'queen mother', 'war of the golden stool', 'resistance'],
    intro: 'A near-historical legend of a woman who rallied the Ashanti during a crisis and became a symbol of resistance.',
    parts: ['When colonial demands threatened sacred objects, Yaa Asantewaa led chiefs and people in defiance that entered national memory as courage and leadership.'],
    qa: { default: 'Her story stands between history and legend, teaching leadership and sacrifice.' },
  },
  {
    id: 'palm-wine-drinking-song',
    title: 'The Palm-Wine Drinker and the Talking Drum',
    keywords: ['palm wine', 'talking drum', 'song', 'drinking'],
    intro: 'A light tale connecting music, drink, and social warning in the market.',
    parts: ['A man’s boastful drinking is answered by a drum that speaks truth in rhythm, teaching moderation and communal memory.'],
    qa: { default: 'Music often carries moral reminders in Ghanaian social life.' },
  },
];

export default AFIA_FOLKTALES_EXTRA;
